<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;padding-bottom:14px;border-bottom: 1px solid rgb(209, 219, 229);">
				<el-tabs  >				
					<el-tab-pane  label="电能表" ></el-tab-pane>
			    </el-tabs>
				<label  style="width: 30px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">项目归属:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 120px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 30px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">能源表名称:</label>
				<el-input style="width: 120px;" placeholder="输入名称" v-model="filterForm.name">
				</el-input>
				<label  style="width: 30px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">能源表地址:</label>
				<el-input style="width: 120px;" placeholder="输入地址" v-model="filterForm.address">
				</el-input>
				<label  style="width: 30px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">时间:</label>
				<div style="display:inline;">
					<el-date-picker style="width:120px;" v-model="searchDay" value-format="yyyyMMdd"  format="yyyyMMdd" type="date" :placeholder="searchDayValue" @change="searchDayOnChange"></el-date-picker>
				</div>
				<el-button style="margin-left: 10px;" @click="queryBtn()">查询</el-button>
				<el-button @click="exportData">数据导出</el-button>
				<div  style="padding-top: 10px;float:left;" >
					<el-select  @change="listSortFn" v-model="filterForm.sortnum"  style="width: 200px;padding-left:12px;">
						<el-option label="按月能耗排序 小->大" value="3s1"></el-option>
						<el-option label="按月能耗排序 大->小" value="3s2"></el-option>
						<el-option label="按日能耗排序 小->大" value="2s1"></el-option>
						<el-option label="按日能耗排序 大->小" value="2s2"></el-option>
						<el-option label="按地址排序" value="1"></el-option>
				    </el-select>
			    </div>
				
		</el-col>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="140" sortable>
			</el-table-column>
			<el-table-column prop="houseNumber" label="对应户号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="name" label="能源表名称" width="140"  sortable>
			</el-table-column>
			<el-table-column prop="address" label="能源表地址" width="150" sortable>
			</el-table-column>
			<el-table-column prop="currentValue" label="电表读数(kwh)" width="120" sortable>
			</el-table-column>
			<el-table-column prop="uploadTime" label="抄表时间" width="140" sortable>
			</el-table-column>
			<el-table-column prop="dayValue" label="日能耗(kwh)" min-width="120" sortable>
			</el-table-column>
			<el-table-column prop="monthValue" label="月能耗(kwh)" min-width="120" sortable>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				filters: {
					name: ''
				},
				filterForm: {
					sortnum:'3s1'
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				cmptTypeList:[],
				sysAppList:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				filterCmptType:'',
				projectList:[],
				searchDay:'',
				searchDayValue:tools.getCurrentYear()+''+tools.getCurrentMonth()+''+tools.getYesterday(),
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			searchDayOnChange(val) {  
				this.searchDayValue = val;  
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			listSortFn(){
				this.get_list_data();
			},
			get_list_data() {
				let param = {
					name:this.filterForm.name,
					address:this.filterForm.address,
					searchDay:this.searchDayValue,
					pageSize: 15,
					pageNum: this.page
				};
				if(this.filterForm.sortnum.search("s") != -1 ){
					var temp = this.filterForm.sortnum.split('s');
					param.sortnum = temp[0];
					param.sortModel = temp[1];
				}
				else{
					param.sortnum = this.filterForm.sortnum;
				}
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				this.listLoading = true;
				api.meterReadReport_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				if(null != param.cmptType){
					if(param.cmptType == 'all')this.filterCmptType = '';
					else this.filterCmptType = param.cmptType;
				}
				this.get_list_data();
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseInt(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					    console.log(temp);
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleDataExport:function () {

			},
			exportData:function () {
				let param = {
					name:this.filterForm.name,
					address:this.filterForm.address,
					searchDay:this.searchDayValue,
				};
				if(this.filterForm.sortnum.search("s") != -1 ){
					var temp = this.filterForm.sortnum.split('s');
					param.sortnum = temp[0];
					param.sortModel = temp[1];
				}
				else{
					param.sortnum = this.filterForm.sortnum;
				}
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				this.listLoading = true;
				api.meterReadReport_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'energyMeterList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
		},
		mounted() {
			this.get_list_data();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// energy_meter_list.vue?00e84d40